import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

import { Dialog, DialogHeader, ErrorState, ForbiddenState, LoadingState } from "@/ds";

import { CartaoAlteracao } from "../cartao-alteracao";
import { TagSimulacao } from "../tag-simulacao";
import { CARREGANDO_LABEL, TITULO_ALTERACOES } from "./detalhe-simulacao-dialog.constants";
import styles from "./detalhe-simulacao-dialog.module.scss";
import type { DetalheSimulacaoDialogViewModel } from "./types-detalhe-simulacao-dialog";

export function DetalheSimulacaoDialogView({
  titulo,
  subtitulo,
  fechar,
  estado,
  mensagem,
  tentarNovamente,
  meta,
  justificativa,
  totalAlteracoes,
  vazio,
  grupos,
}: DetalheSimulacaoDialogViewModel) {
  return (
    <Dialog
      visible
      size="xl"
      className={styles.dialog}
      contentClassName={styles.content}
      header={
        <DialogHeader
          title={
            <>
              {titulo}
              <TagSimulacao />
            </>
          }
          subtitle={subtitulo}
          classNames={{ title: styles.titulo }}
        />
      }
      footer={
        <Button
          type="button"
          label="Fechar"
          severity="secondary"
          outlined
          onClick={fechar}
          data-testid="detalhe-historico-fechar"
        />
      }
      onHide={fechar}
      breakpoints={{ "76rem": "95vw", "48rem": "100vw" }}
      data-testid="detalhe-historico-dialog"
    >
      {estado === "loading" ? (
        <div className={styles.estado}>
          <LoadingState label={CARREGANDO_LABEL} testId="detalhe-loading" />
        </div>
      ) : null}

      {estado === "forbidden" ? (
        <div className={styles.estado}>
          <ForbiddenState description={mensagem ?? undefined} testId="detalhe-forbidden" />
        </div>
      ) : null}

      {estado === "error" ? (
        <div className={styles.estado}>
          <ErrorState
            message={mensagem ?? undefined}
            onRetry={tentarNovamente}
            testId="detalhe-erro"
          />
        </div>
      ) : null}

      {estado === "success" ? (
        <div className={styles.detalhe}>
          <div className={styles.meta} aria-label="Resumo">
            {meta.map((item) => (
              <div key={item.chave} className={styles.metaItem}>
                <span className={styles.metaRotulo}>{item.rotulo}</span>
                <p className={styles.metaValor} data-testid={item.testId}>
                  {item.valor}
                </p>
              </div>
            ))}
            {justificativa ? (
              <div className={styles.justificativa}>
                <span className={styles.metaRotulo}>Justificativa</span>
                <p className={styles.justificativaTexto} data-testid="detalhe-justificativa">
                  {justificativa}
                </p>
              </div>
            ) : null}
          </div>

          <section
            className={styles.alteracoes}
            aria-labelledby="detalhe-titulo-alteracoes"
            data-testid="detalhe-secao-alteracoes"
          >
            <h2 id="detalhe-titulo-alteracoes" className={styles.tituloAlteracoes}>
              {TITULO_ALTERACOES}
              <span className={styles.contagem}>{totalAlteracoes}</span>
            </h2>

            {vazio ? (
              <p className={styles.vazio} data-testid={vazio.testId}>
                {vazio.texto}
              </p>
            ) : null}

            {grupos.map((grupo) => (
              <section
                key={grupo.categoria}
                className={styles.grupo}
                aria-label={grupo.rotulo}
                data-testid={grupo.testId}
              >
                <ul className={styles.lista}>
                  {grupo.alteracoes.map(({ chave, cartoes }) => (
                    <li key={chave} className={styles.alteracao} data-testid="detalhe-alteracao">
                      {cartoes.map(({ cartao, falha, mensagem: resultado, estado: tag }) => (
                        <CartaoAlteracao
                          key={cartao.id}
                          cartao={cartao}
                          falha={falha}
                          mensagem={resultado}
                        >
                          {tag ? (
                            <Tag
                              className="p-tag-compact"
                              severity={tag.severity}
                              icon={tag.icone}
                              value={tag.rotulo}
                              data-estado={tag.estado}
                              data-testid="detalhe-item-estado"
                            />
                          ) : null}
                        </CartaoAlteracao>
                      ))}
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </section>
        </div>
      ) : null}
    </Dialog>
  );
}
